import { Controller } from "@hotwired/stimulus"

// Popup zgód marketingowych — bazuje na wzorcu banner_controller
// localStorage przechowuje: dismissCount, lastShownAt
// Po 3x dismiss → wysyła "refuse" do serwera i ukrywa na stałe
export default class extends Controller {
  static values = {
    url: String, // URL endpointu POST
    hideDays: { type: Number, default: 30 },
    maxDismiss: { type: Number, default: 3 },
    userKey: String
  }

  static targets = ["checkbox", "acceptTip", "refuseTip"]

  connect() {
    const saved = localStorage.getItem(this._storageKey())
    if (saved) {
      try {
        const data = JSON.parse(saved)
        const now = new Date().getTime()

        if (data.refused) {
          this.element.remove()
          return
        }

        if (data.dismissCount >= this.maxDismissValue) {
          this._serverRefuse()
          this.element.remove()
          return
        }

        if (data.lastShownAt && now < data.lastShownAt + this.hideDaysValue * 24 * 60 * 60 * 1000) {
          this.element.remove()
          return
        }

        this._show()
      } catch {
        localStorage.removeItem(this._storageKey())
        this._show()
      }
    } else {
      this._show()
    }
  }

  accept() {
    // Akceptacja wymaga zaznaczenia min. jednej zgody — inaczej podpowiadamy, co zrobić.
    if (!this._anyChecked()) {
      this._showTip(this.acceptTipTarget)
      return
    }
    const consents = {}
    this.checkboxTargets.forEach(cb => {
      consents[cb.dataset.field] = cb.checked ? "1" : "0"
    })

    this._post("accept", consents)
    this._markRefused() // nie pokazuj więcej po akceptacji
    this.element.remove()
  }

  checkboxChanged() {
    // Zmiana zaznaczenia czyści ewentualną podpowiedź — user właśnie koryguje wybór.
    this._hideTips()
  }

  refuse() {
    // Odmowa wszystkiego wymaga odznaczenia wszystkich zgód — inaczej podpowiadamy, co zrobić.
    if (this._anyChecked()) {
      this._showTip(this.refuseTipTarget)
      return
    }
    this._post("refuse", {})
    this._markRefused()
    this.element.remove()
  }

  dismiss() {
    const saved = JSON.parse(localStorage.getItem(this._storageKey()) || "{}")
    const dismissCount = (saved.dismissCount || 0) + 1
    localStorage.setItem(this._storageKey(), JSON.stringify({
      dismissCount,
      lastShownAt: new Date().getTime()
    }))

    if (dismissCount >= this.maxDismissValue) {
      this._serverRefuse()
    }

    this.element.remove()
  }

  _show() {
    this.element.classList.remove("hidden")
  }

  _anyChecked() {
    return this.checkboxTargets.some(cb => cb.checked)
  }

  _showTip(tip) {
    this._hideTips()
    tip.classList.remove("hidden")
  }

  _hideTips() {
    if (this.hasAcceptTipTarget) this.acceptTipTarget.classList.add("hidden")
    if (this.hasRefuseTipTarget) this.refuseTipTarget.classList.add("hidden")
  }

  _storageKey() {
    return `marketing_consent_popup_${this.userKeyValue}`
  }

  _markRefused() {
    localStorage.setItem(this._storageKey(), JSON.stringify({ refused: true }))
  }

  _serverRefuse() {
    this._post("refuse", {})
    this._markRefused()
  }

  _post(response, consents) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ response, consents })
    }).then(r => {
      if (!r.ok) console.warn(`[marketing-consent] server error ${r.status} for response="${response}"`)
    }).catch(err => {
      console.warn("[marketing-consent] network error:", err)
    })
  }
}
